import { Turbo } from "@hotwired/turbo-rails";
import "@lib/preline_loader";
import { application } from "@controllers/application";
import MapsController from "@controllers/preline/google_maps/google_maps";
import CarouselController from "@controllers/preline/carousel/carousel";
import VenueController from "@controllers/dashboard/memorial_venues/venue";
import ModalController from "@controllers/preline/modal/modal";
import ContentSwitch from "@controllers/shared/content_switch/content_switch";
import DropdownController from "@controllers/shared/dropdown/dropdown";

application.register("google_maps", MapsController);
application.register("carousel", CarouselController);
application.register("venue", VenueController);
application.register("modal", ModalController);
application.register("content_switch", ContentSwitch);
application.register("dropdown", DropdownController);

Turbo.session.drive = false;
document.documentElement.addEventListener("turbo:frame-load", () => {
  window.HSStaticMethods.autoInit();
});

// Ensure that autoInit is called after Turbo streams render
document.documentElement.addEventListener("turbo:before-stream-render", (event) => {
  const render = event.detail.render;

  event.detail.render = function (streamElement) {
    render(streamElement);
    window.HSStaticMethods.autoInit();

    const resizeEvent = new Event("resize");
    window.dispatchEvent(resizeEvent);

    const customEvent = new CustomEvent("turbo:after-stream-render", { detail: streamElement });
    document.dispatchEvent(customEvent);
  };
});
